import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendBrandVoice, BackendMutationDeleteBrandVoiceArgs } from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteBrandVoice($id: ID!) {
    deleteBrandVoice(id: $id) {
      id
    }
  }
`;

type Variables = BackendMutationDeleteBrandVoiceArgs;
type Result = Pick<BackendBrandVoice, 'id'>;

export const deleteBrandVoice = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
